import React from 'react';
import { extractGraphqlErrors } from '../../errors';
import Alert from './Alert';
import useTranslation from './Translations/useTranslation';
const extractGraphqlErrorMessage = (error, t) => {
    const errors = extractGraphqlErrors(error, t);
    if (!errors) {
        return null;
    }
    if (errors['']) {
        return errors[''];
    }
    return Object.values(errors).join('; ');
};
const extractHumanErrorMessage = (error, t) => error.humanErrorMessage ? t(error.humanErrorMessage) : null;
export const extractErrorMessage = (error, t) => extractGraphqlErrorMessage(error, t) || extractHumanErrorMessage(error, t);
const Error = ({ inline = false, error = null }) => {
    const { t } = useTranslation();
    let message = extractErrorMessage(error, t);
    let title = '';
    if (!message) {
        title = t('Something went wrong');
        message = t('Please try again later');
    }
    return <Alert inline={inline} message={message} title={title}/>;
};
export default Error;
